// extracted by mini-css-extract-plugin
module.exports = {"jackpot":"_a61604f"};